import { ValidationRules, SelectionValue } from "@components/library/inputs/Input.props";

const validateIsRequired = (inputValue: string): string => (
  (!!inputValue && inputValue.length > 0)
    ? ''
    : bfTranslate('Input required')
);

const validateMinLength = (inputValue: string, minLength: number): string => (
  (!!inputValue && inputValue.length >= minLength)
    ? ''
    : bfTranslate(`At least ${minLength} characters required`)
);

const validateIsEmail = (inputValue: string): string => {
  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
  return emailRegex.test(inputValue.toLowerCase())
    ? ''
    : bfTranslate('A valid email is required');
};

const validatePasswordRequirements = (inputValue: string): string => {
  const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  return passwordRegex.test(inputValue)
    ? ''
    : bfTranslate('Password must include upper and lowercase letters and at least one number');
};

const isSelectionValue = (inputValue: string | SelectionValue):
  inputValue is SelectionValue => !!(inputValue as SelectionValue).value;

export const validate = (inputValue: string | SelectionValue, rules: ValidationRules): string => {
  let error = '';
  if (!rules.isRequired) return error;
  if (isSelectionValue(inputValue)) return error;
  Object.keys(rules).forEach((rule) => {
    const ruleValue = rules[rule];

    switch (rule) {
      case 'isRequired':
        error = error || validateIsRequired(inputValue);
        break;
      case 'minLength':
        error = error || validateMinLength(inputValue, ruleValue);
        break;
      case 'isEmail':
        error = error || validateIsEmail(inputValue);
        break;
      case 'isPassword':
        error = error || validatePasswordRequirements(inputValue);
        break;
      default: break;
    }
  });
  return error;
};
